import React from 'react';
import { createPortal } from 'react-dom';
import { observer, inject } from 'mobx-react';
import { action, observable, computed } from 'mobx';
import { isIphoneX } from '../../utils/util';
import DanSwitch from '../Switch/DanSwitch';
import PopUpCommentWrapper from './PopUpCommentWrapper';
import ResizeHiddenWrapper from '../Common/ResizeHiddenWrapper';
import SendMessage from './SendMessage';
@inject('rootStore')
@observer
class CommentPendant extends React.Component {
  @observable on = localStorage['danSwitch'] === '0' ? false : true;
  @action setSwitch = value => {
    if (typeof value === 'boolean') {
      this.on = value;
    } else {
      this.on = !this.on;
    }
    //localStorage存储的反正都是字符串
    localStorage['danSwitch'] = this.on ? '1' : '0';
  };
  @computed get theBottom() {
    const flag = isIphoneX();
    const eXBottom = flag ? 20 : 0;
    return typeof this.props.bottom === 'number'
      ? this.props.bottom + eXBottom
      : 50 + eXBottom;
  }

  render() {
    //const {commentStore} = this.props.rootStore;
    //console.log(this.props.bottom);
    return (
      <ResizeHiddenWrapper>
        <div
          style={{
            position: 'fixed',
            left: 13,
            right: 13,
            bottom: this.theBottom,
            pointerEvents: 'none'
          }}
        >
          {this.on && <PopUpCommentWrapper type={this.props.type} />}

          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: 10
            }}
          >
            <DanSwitch on={this.on} setSwitch={this.setSwitch} />
            {this.on && (
              <SendMessage
                onClick={this.props.onSend}
                number={this.props.total}
              />
            )}
          </div>
        </div>
      </ResizeHiddenWrapper>
    );
  }
}

export default CommentPendant;
